<template>
    <NuxtLink :to="linkTo" :target="target" external>
        <slot></slot>
    </NuxtLink>
</template>
<script setup lang="ts">

const props = defineProps({
    to: {
        type: String,
        required: true,
    },
    tooltip: {
        type: Boolean,
        required: false,
    }
});

const config = useRuntimeConfig()
const route = useRoute();

const linkTo = computed<string>(() => {
    let url = props.to
    if (!config.public.isProduction && route.query.collection) {
        url = `${url}?collection=${route.query.collection}`
    }
    return url
})

const target = computed(() => linkTo.value.startsWith('http') ? '_blank' : '')

</script>